<template>
  <section v-if="getShowCommercialCampaign" class="wrapper-campaign">
    <header>
      <h1>Campanha de Discagem Hot Lead</h1>
    </header>

    <div class="scheduled-clients-button">
      <button class="btn btn-info scheduled-btn" @click="showScheduledClients"><i class="fa-solid fa-calendar-day"
          style="font-size: 15px;"></i>
        Agenda
      </button>
    </div>

    <div v-if="validateClients" class="wrapper-clients-info">
      <div v-if="showCurrentClient"
        :class="['client-info', 'current-client', (showCurrentClient.redial || showCurrentClient.schedule_date) && 'redial-client', (!showCurrentClient.redial && !showCurrentClient.schedule_date && showCurrentClient.tab) && 'tabulated-client']">
        <h1>Cliente Atual</h1>
        <span><b>Cliente: </b> {{ showCurrentClient.client_name }}</span>
        <span><b>Email: </b>{{ showCurrentClient.email }}</span>
        <span><b>Telefone: </b>{{ showCurrentClient.client_phone }}</span>
        <span><b>Whatsapp: </b>{{ showCurrentClient.whatsapp }}</span>
        <span><b>Funcionarios: </b>{{ showCurrentClient.number_employes }}</span>
        <span><b>Faturamento Mensal: </b>{{ formatMoney(showCurrentClient.monthly_billing) }}</span>
        <span v-if="showCurrentClient.tab"><b>Tabulação: </b>{{ convertTabOption(showCurrentClient.tab) }}</span>
        <span v-if="showCurrentClient.tab"><b>Descrição: </b>{{ showCurrentClient.tab_obs }}</span>

        <div class="wrapper-dial-now">
          <button class="btn" :class="{ 'btn-primary': isDialEnabled, 'btn-secondary': !isDialEnabled }"
            @click="dialCurrentClient" :disabled="!isDialEnabled">
            <span>Discar para {{ showCurrentClient.client_name }}</span>
            <i class="fas fa-phone"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-else class="wrapper-no-clients">
      <h1>Sem Clientes</h1>
      <i class="fas fa-ban"></i>
    </div>

    <hr>

    <div v-if="validateClients" class="wrapper-timer">
      <section>
        <div class="clock-wrap">
          <div class="clock pro-0">
            <span class="count">{{ count }}</span>
          </div>
        </div>
      </section>
    </div>

  </section>
</template>


<script>
const socketAMI = io.connect(`${location.protocol}//${location.hostname}:3006/`);
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "CommercialDialCampaign",
  data() {
    return {
      campaignTimer: 10,
      campaignClients: [],
      countdown: true,
      tabOptions: [],
      timeBetweenCampaigns: false,
      interval: null,
      half: 0,
      barColor: "#00b4d8",
      backColor: "#feeff4",
      count: 0,
      inCall: false,
      isDialEnabled: false,
      isUpdatingCampaign: false,
      isUpdatingClient: false,
    };
  },
  methods: {
    ...mapActions([
      "setCallData",
    ]),
    dialCurrentClient() {
      if (this.inCall || !this.isDialEnabled) return;
      if (this.validateClients) {
        const clientPhone = this.formatPhoneToCall(this.campaignClients[0].client_phone);
        socketAMI.emit('OriginateTab', {
          calltype: 'outgoing',
          extension: user.getExtension(),
          phone: `0${clientPhone}`,
        });
      }
    },

    async showScheduledClients() {
      await this.checkClients();
      const check = this.clients;
      const notifiedClients = new Set();
      let isNotifying = false;
      let notifiedSwal = false;

      if (check) check.sort((a, b) => moment(a.schedule_date).unix() - moment(b.schedule_date).unix());

      if (check.length && !isNotifying) {

        const upcomingSchedules = check.filter(client => {
          const scheduleTime = moment(client.schedule_date);
          const now = moment();
          const diffInMinutes = scheduleTime.diff(now, 'minutes');
          return diffInMinutes <= 60 && diffInMinutes >= 0;
        }).map(client => ({
          clientName: client.client_name,
          time: moment(client.schedule_date).format('HH:mm')
        }));

        // Se houver clientes agendados, mostra o SweetAlert
        if (upcomingSchedules.length > 0 && !notifiedSwal) {
          let scheduleListHTML = '<ul style="list-style-type: none; padding: 0; margin: 0;">';
          upcomingSchedules.forEach(schedule => {
            scheduleListHTML += `
                <li style="padding: 8px 15px; font-size: 14px; display: flex; justify-content: space-between; align-items: center; background-color: #ffffff; border-radius: 5px; margin-bottom: 5px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); transition: background-color 0.3s ease, box-shadow 0.3s ease;" onmouseover="this.style.backgroundColor='#f1f1f1'; this.style.boxShadow='0 2px 5px rgba(0,0,0,0.15)';" onmouseout="this.style.backgroundColor='#ffffff'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)';">
                    <strong style="color: #1a6fa5;">${schedule.clientName}</strong>
                    <span style="color: #16a085; font-weight: bold;">${schedule.time}</span>
                </li>`;
          });
          scheduleListHTML += '</ul>';

          const totalClients = upcomingSchedules.length;
          Swal.fire({
            toast: true,
            position: 'top-end',
            html: `
                  <div style="font-family: 'Arial', sans-serif; max-width: 300px; text-align: center;">
                      <div style="display: flex; justify-content: center; align-items: center; background-color: #16a085; border-radius: 50%; width: 50px; height: 50px; margin: 0 auto; color: #fff;">
                          <i class="fas fa-calendar-check" style="font-size: 24px;"></i>
                      </div>
                      <h3 style="color: #2c3e50; margin: 20px 0 10px 0; font-size: 18px; font-weight: bold;">
                          Clientes Agendados!
                      </h3>
                      <div style="max-height: 200px; overflow-y: auto; padding-right: 5px;">
                          ${scheduleListHTML}
                      </div>
                      <p style="color: #555; font-size: 14px; margin-top: 15px;">
                        Existem <strong style="color: #e74c3c;">${totalClients}</strong> clientes agendados em até 1 hora.
                      </p>
                  </div>
              `,
            showCloseButton: true,
            showConfirmButton: false,
            background: '#ecf0f1',
            customClass: {
              popup: 'animated fadeInDown'
            }
          });

          notifiedSwal = true;

          // Adiciona os clientes notificados
          upcomingSchedules.forEach(schedule => {
            const client = check.find(c => moment(c.schedule_date).format('HH:mm') === schedule.time);
            if (client) notifiedClients.add(client.id);
          });

          // Reseta a notificação após 5 minutos
          setTimeout(() => {
            notifiedSwal = false;
          }, 300000); // 5 minutos
        }
      } else if (!notifiedSwal) {
        // Se não houver clientes agendados, mostra um alerta diferente
        Swal.fire({
          toast: true,
          position: 'top-end',
          html: `
                <div style="font-family: 'Arial', sans-serif; max-width: 300px; text-align: center;">
                    <div style="display: flex; justify-content: center; align-items: center; background-color: #e74c3c; border-radius: 50%; width: 50px; height: 50px; margin: 0 auto; color: #fff;">
                        <i class="fas fa-calendar-xmark" style="font-size: 24px;"></i>
                    </div>
                    <h3 style="color: #2c3e50; margin: 20px 0 10px 0; font-size: 18px; font-weight: bold;">
                        Sem Clientes Agendados
                    </h3>
                    <p style="color: #555; font-size: 14px; margin-bottom: 20px;">
                        Sem clientes agendados em até 1 hora.
                    </p>
                </div>
            `,
          showCloseButton: true,
          showConfirmButton: false,
          background: '#ecf0f1',
          customClass: {
            popup: 'animated fadeInDown'
          }
        });

        notifiedSwal = true;

        // Reseta a notificação após 5 minutos
        setTimeout(() => {
          notifiedSwal = false;
        }, 300000); // 5 minutos
      }
    },
    async startFromHangup() {
      this.inCall = false;
      await this.updateClient(this.campaignClients[0], this.getCallData);
      this.getCallData.tab_obs = null;
      this.getClients();
      this.startCountdown();
    },

    async delaySendingCall(ms = 1000) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    async deactivateCampaignAndSetDefault() {
      const response = await axios.post('/desactivateCampaign');

      if (response.data.success) {
        const deactivatedCampaign = response.data.deactivated_campaign;
        Swal.fire({
          html: `
          <div style="text-align: center; font-family: 'Arial', sans-serif; color: #333;">
            <img src="/imgs/calendar.gif" alt="Timer" style="margin-bottom: 5px; max-width: 125px; display: block; margin: 0 auto;"/>
            <hr>
            <p style="font-size: 1.5em; font-weight: bold; color: #D32F2F; margin: 15px 0;">
              <span style="font-style: italic;">${deactivatedCampaign}</span>
            </p>
            <p style="font-size: 1.05em; margin: 5px 0; line-height: 1.3;">
              A campanha foi desativada por exceder os 5 dias limites de ativação.
            </p>
            <p style="font-size: 0.85em; color: #555;">Se precisar de mais informações, entre em contato com o suporte.</p>
          </div>`,
          showConfirmButton: true,
          confirmButtonText: '<i class="fa-regular fa-circle-check"></i>',
          confirmButtonColor: '#4CAF50',
          allowOutsideClick: false,
          footer: `
          <div style="text-align: center;">
            <span style="font-size: 0.75em; color: #AAA;">Obrigado por usar nosso sistema!</span><br/>
            <span style="font-size: 0.75em; color: #AAA;">Powered by <strong>Advance</strong></span>
            <img src="imgs/advance-logo.png" alt="Logo da Advance" style="max-width: 20px; margin-left: 5px; vertical-align: middle;" />
          </div>`,
          customClass: {
            popup: 'animated bounceIn',
          },
          backdrop: `rgba(0, 0, 0, 0.4) 
                      left top
                      no-repeat`,
          onBeforeOpen: () => {
            const confirmButton = Swal.getConfirmButton();
            confirmButton.setAttribute("style", `
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            margin: -15px; 
            border-radius: 30px !important; 
            background-color: #4CAF50 !important; 
            color: white; 
            width: 50px; 
            height: 50px;
            display: flex; 
            justify-content: center; 
            align-items: center;
            font-size: 24px;`);
          }
        });
        sessionStorage.removeItem("campaignClient");
      }
    },

    // Função que busca clientes agendados ou campanhas
    async getClients() {
      if (this.isUpdatingCampaign) return; // Se já estiver atualizando, evita duplicação
      this.isUpdatingCampaign = true; // Marca como em atualização

      try {
        await this.deactivateCampaignAndSetDefault();
        const clientSession = sessionStorage.getItem("campaignClient");
        if (clientSession && clientSession !== "undefined") {
          this.campaignClients = [JSON.parse(clientSession)];
          return;
        }

        const currentTime = moment().format('HH:mm');

        const { data: scheduledClients } = await axios.get("/generateCommercialCampaignScheduleds");

        const clientsScheduledForNow = scheduledClients.filter(client => {
          const clientScheduleTime = moment(client.schedule_date).format('HH:mm');
          return clientScheduleTime <= currentTime;
        });

        if (clientsScheduledForNow.length > 0) {
          this.campaignClients = clientsScheduledForNow;
          sessionStorage.setItem("campaignClient", JSON.stringify(clientsScheduledForNow[0]));
          return;
        }

        const { data: defaultClients } = await axios.get("/generateCommercialCampaign");
        await this.delaySendingCall(1000);

        const orderedClients = defaultClients.sort((a, b) => a.redial_count - b.redial_count);

        this.campaignClients = orderedClients;

        if (this.campaignClients.length > 0) {
          sessionStorage.setItem("campaignClient", JSON.stringify(this.campaignClients[0]));
        }
      } catch (error) {
        console.error("Erro ao obter clientes agendados:", error);
      } finally {
        this.isUpdatingCampaign = false;
      }
    },
    startClientCheckInterval() {
      this.clientCheckInterval = setInterval(() => {
        if (!sessionStorage.getItem("campaignClient")) {
          this.getClients();
          this.startCountdown();
        }
      }, 10000); // Intervalo de 10 segundos
    },

    stopClientCheckInterval() {
      if (this.clientCheckInterval) {
        clearInterval(this.clientCheckInterval);
      }
    },

    getTabOptions() {
      axios.get("/listTabOptions")
        .then(({ data }) => {
          this.tabOptions = data;
        });
    },

    async checkClients() {
      await axios.get("/getScheduledCalls")
        .then(({ data }) => {
          this.clients = data;
        });
    },

    async updateClient(client, callData) {
      const recalCase = {
        2: true,
        8: true,
      };


      client.call_id = callData.call_id || null;
      client.tab = callData.tab || null;
      client.tab_obs = callData.tab_obs || null;
      client.schedule_date = callData.scheduling_datetime || null;

      if (callData.tab == 3) {
        if (!client.tab_obs) client.tab_obs = "Agendamento: " + moment(callData.scheduling_datetime).format("DD/MM/YYYY HH:mm:ss");
        client.schedule_check = 1;
      }

      if (callData.tab != 3) {
        client.schedule_date = null;
        callData.scheduling_datetime = null;
        client.schedule_check = 1;
      }

      if (recalCase[callData.tab]) {
        if (client.redial) {
          client.redial_count = (client.redial_count || 0) + 1;
        } else {
          client.redial = true;
          client.redial_count = 1;
        }

        const redial_date = moment().startOf('day').format('YYYY-MM-DD');

        if (client.redial_count === 3) {
          client.tab_obs = "Limite de rediscagem atingido, não foi possivel contactar o cliente!";
          client.redial = false;
          client.last_redial_date = redial_date;
        }
      } else {
        client.redial = false;
      }

      return await axios.put("updateCommercialCampaign", client)
        .then(({ data }) => {
          sessionStorage.removeItem("campaignClient");
          this.setCallData({
            call_id: null,
            tab: null,
            tab_obs: null,
            scheduling_datetime: null,
          });
        });

    },

    listeningCalls() {
      socketAMI.on(`CoreShowChannel-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });

      socketAMI.on(`NewConnectedLine-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });
    },
    async listeningHangupRinging() {
      socketAMI.on(`HangupRinging-${user.getExtension()}`, async () => {
        if (this.isUpdatingClient) return; 
        this.isUpdatingClient = true;

        const callData = {
          call_id: null,
          tab: 8,
          tab_obs: "Discagem recusada pelo operador",
        };

        this.inCall = false;

        if (this.campaignClients.length > 0) {
          try {
            await this.updateClient(this.campaignClients[0], callData);
            await this.getClients();
          } catch (error) {
            console.error("Erro ao processar recusa da chamada:", error);
          } finally {
            this.isUpdatingClient = false;
            this.startCountdown();
          }
        } else {
          this.stopCountdown();
          this.isUpdatingClient = false;
        }
      });
    },

    formatPhoneToCall(phone) {
      let newPhone = phone.replace(/\D/g, "");
      newPhone = newPhone.slice(0, 2) == "55" ? newPhone.slice(2) : newPhone;
      return newPhone;
    },
    formatMoney(value) {
      if (value === null || value === undefined) return '';

      const numericValue = value.toString().replace(/[^\d.,]/g, '');

      const cleanedValue = numericValue.replace(',', '.');

      const floatValue = parseFloat(cleanedValue);

      if (isNaN(floatValue)) return '';
      return floatValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    formatCpfCnpj(value) {
      const cnpjCpf = value?.replace(/\D/g, '');
      if (cnpjCpf?.length === 11) {
        return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
      }

      return cnpjCpf?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
    },
    convertTabOption(option) {
      return this.tabOptions[option] || "";
    },
    async startCountdown() {
      this.clearCountdown();
      let pie = 0;
      let num = 0;
      let sec = 15;
      let lop = sec;
      this.count = sec;
      this.isDialEnabled = false;
      $(".count").addClass("sec");

      this.interval = setInterval(() => {
        sec = sec - 1;
        pie = pie + 100 / lop;

        if (pie >= 101) {
          pie = 1;
        }

        num = (sec / 60).toFixed(2).slice(0, -3);
        if (num == 0) {
          $(".count").removeClass("min").addClass("sec");
          this.count = sec;
        } else {
          $(".count").removeClass("sec").addClass("min");
          this.count = num;
        }

        let indx = pie.toFixed(2).slice(0, -3) - 1;
        if (indx < this.half) {
          let nextdeg = 90 + this.increment * indx + "deg";
          $(".clock").css({
            "background-image": "linear-gradient(90deg," + this.backColor + " 50%,transparent 50%,transparent),linear-gradient(" + nextdeg + "," + this.barColor + " 50%," + this.backColor + " 50%," + this.backColor + ")",
          });
        } else {
          let nextdeg = -90 + this.increment * (indx - this.half) + "deg";
          $(".clock").css({
            "background-image": "linear-gradient(" + nextdeg + "," + this.barColor + " 50%,transparent 50%,transparent),linear-gradient(270deg," + this.barColor + " 50%," + this.backColor + " 50%," + this.backColor + ")",
          });
        }

        if (sec == 0) {
          this.stopCountdown();
        }
      }, 1000);

      setTimeout(() => {
        this.isDialEnabled = true;
      }, 2000);
    },
    stopCountdown() {
      this.clearCountdown();
      this.dialCurrentClient();
      this.countdown = false;
    },
    clearCountdown() {
      clearInterval(this.interval);
      this.count = 0;
      $(".clock").removeAttr("style");
    },
    saveClientOnCookie() {
      if (this.validateClients) {
        window.document.cookie = JSON.stringify(this.campaignClients[0]);
      } else {
        window.document.cookie = "";
      }
    },

    async maxRedialClients() {
      await axios.get("/maxRedialAttempt")
        .then(({ data }) => {
          const today = moment().startOf('day').unix();
          this.maxRedial = data.filter(client => {
            const lastRedialDate = moment(client.last_redial_date).startOf('day').unix();

            if (today > lastRedialDate) {
              axios.post('/saveRedialHistory', {
                client_id: client.id,
                redial_date: client.last_redial_date,
                redial_count: client.redial_count
              })
                .then(historyResponse => {
                  return axios.put('/resetRedialAttempt', {
                    id: client.id,
                    redial: 1,
                    redial_count: 0
                  });
                })
                .then(response => {
                  console.log(`Cliente ${client.id} resetado com sucesso`);
                })
                .catch(error => {
                  console.error(`Erro ao processar cliente ${client.id}:`, error);
                });
            }
          });
        });
    },
  },
  async beforeMount() {
    this.getClients();
    this.getTabOptions();
    this.listeningHangupRinging();
    this.listeningCalls();
  },

  mounted() {
    const step = 1;
    const loops = Math.round(100 / step);
    this.increment = 360 / loops;
    this.half = Math.round(loops / 2);
    this.barColor = "#00b4d8";
    this.backColor = "#feeff4";

    if (this.getShowCommercialCampaign && !this.inCall) {
      this.startCountdown();
    }
    this.startClientCheckInterval();
    this.maxRedialClients();
  },
  beforeDestroy() {
    this.clearCountdown();
    this.stopClientCheckInterval();
  },
  computed: {
    ...mapGetters([
      "getShowCommercialCampaign",
      "getStartCampaign",
      "getCallData",
    ]),
    validateClients() {
      return this.campaignClients.length > 0;
    },
    showCurrentClient() {
      return this.campaignClients[0] || false;
    },
  },
  watch: {
    getStartCampaign() {
      this.startFromHangup();
    },
    getShowCommercialCampaign() {
      if (this.getShowCommercialCampaign && !this.inCall) {
        this.startCountdown();
      }
    }
  },
};
</script>

<style scoped>
.tabulated-client {
  background-color: #d4edda;
  /* Cor de fundo verde clara */
  border-color: #c3e6cb;
  /* Bordas mais suaves */
}

.btn-confirm {
  border-radius: 30px !important;
}

.custom-confirm-button {
  border-radius: 8px !important;
  margin: -15px;
}

.btn-secondary {
  background-color: gray;
  /* Cor cinza para o botão desativado */
  color: white;
  /* Cor do texto */
  cursor: not-allowed;
  /* Mudar o cursor para indicar que está desativado */
}


.scheduled-clients-button {
  position: absolute;
  right: 0;
  top: 0;
  margin: 45px;
}

.scheduled-btn {
  background-color: #007bff;
  color: white;
  border-radius: 20px !important;
  margin: 0;
  padding: 10px 30px;
  font-weight: bold;
  font-size: 13px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s, transform 0.2s;
  border: none;
}

.scheduled-btn:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}



.wrapper-campaign {
  padding: 10px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.wrapper-campaign header {
  height: 100px;
  margin-bottom: 20px;
  border-radius: 10px 10px 0px 0px;
  background: rgb(28, 134, 154);
  background: linear-gradient(180deg, rgba(28, 134, 154, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

.wrapper-campaign h1 {
  text-align: center;
}

.wrapper-campaign header>h1 {
  font-size: 3rem;
  color: #fff;
}

.wrapper-clients-info {
  display: flex;
  justify-content: space-around;
}

.wrapper-no-clients {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-no-clients i {
  font-size: 60px;
  color: red;
}

.client-info {
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  font-size: 1.5rem;
}

.current-client {
  width: 100%;
  border-right: solid 1px #cccccc;
}

.next-client {
  width: 40%;
  border-left: solid 1px #cccccc;
}

.redial-client {
  background: #ffeba1;
  background: linear-gradient(90deg, #ffeba1 0%, rgba(255, 255, 255, 1) 90%);
}

.no-clientes {
  width: 40%;
  align-items: center;
  justify-content: space-evenly;
}

.no-clientes i {
  font-size: 60px;
  color: red;
}

.wrapper-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-dial-now {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 5px;
}

.wrapper-dial-now button {
  border-radius: 8px !important;
}

.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
  display: block;
}

.clock:before,
.count:after {
  content: "";
  position: absolute;
}

.clock-wrap {
  margin: auto;
  width: 225px;
  height: 225px;
  margin: 25px 0px;
  position: relative;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.clock {
  top: 50%;
  left: 50%;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  position: absolute;
  margin-top: -90px;
  margin-left: -90px;
  background-color: #feeff4;
}

.clock:before {
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  margin-top: -60px;
  margin-left: -60px;
  border-radius: inherit;
  background-color: #00b4d8;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15),
    0 0 3px rgba(255, 255, 255, 0.75) inset;
  /*border:1px solid rgba(255,255,255,.1);*/
}

.count {
  width: 100%;
  color: #fff;
  height: 100%;
  padding: 50px;
  font-size: 32px;
  font-weight: 500;
  line-height: 50px;
  position: absolute;
  text-align: center;
}

.count:after {
  width: 100%;
  display: block;
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
  text-align: center;
  position: relative;
}

.count.sec:after {
  content: "sec";
}

.count.min:after {
  content: "min";
}

.action {
  margin: auto;
  max-width: 200px;
}

.action .input {
  margin-top: 30px;
  position: relative;
}

.action .input-num {
  width: 100%;
  border: none;
  padding: 12px;
  border-radius: 60px;
}

.action .input-btn {
  top: 0;
  right: 0;
  color: #fff;
  border: none;
  border: none;
  padding: 12px;
  position: absolute;
  border-radius: 60px;
  background-color: #00b4d8;
  text-transform: uppercase;
}

.tbl {
  display: table;
  width: 100%;
}

.tbl .col {
  display: table-cell;
}
</style>